import React, { Component } from "react";
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from "@syncfusion/ej2-react-popups";

class ContentDetails extends Component {
  constructor() {
    super();
    this.dialogClose = () => {
      this.setState({ hideDeletePopup: false });
    };

    this.settings = { effect: "Zoom", duration: 400, delay: 0 };

    //for delete dialog component ok click
    this.buttons = [
      {
        buttonModel: {
          content: "Yes",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: (props) => {
          // this.deleteAnswersApi(this.state.propsId);
          this.setState({ disabled: false });
        },
      },
      {
        buttonModel: {
          content: "No",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.setState({
            hideDeletePopup: false,
            disabled: false,
          });
        },
      },
    ];

    this.state = {
      language: null,
      data: [],
      pageNum: null,
      faqid: "",
      disabled: false,
      editedId: "-1",
      editImageSrc: "./assets/images/edit2.png",
      hidden: false,
      hideAddDialog: false,
      hideupdateDialog: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      showContentOverlay: false,
      contentList: [],
      content: "",
      projectWebsiteId: "",
      isLoading: false,
    };
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
  }

  NotifyFailToLoad() {
    toast.dismiss();
    toast(
      <b style={{ color: "red" }}>Oops! Error occurred.Please try again</b>,
      {
        position: "top-center",
        color: "red",
      }
    );
  }

  addRow = (data) => {
    var ansController = this;
    if (ansController.state.pageNum != 0) {
      ansController.setState({ pageNum: 0 });
    }
    this.state.data.unshift({
      id: "",
      answer: "",
      autoTranslate: "",
    });
    this.setState({
      data: this.state.data,
      disabled: true,
    });
  };

  NotifyAdd() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Answer Added Successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyFailedToAdd(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  makeCelleditable(props, e) {
    this.markAsBeingEdited(this.state.data[props.index].id);
  }
  markAsBeingEdited(id) {
    this.state.editedId = id;
    var stateObj = this.state;
    this.setState(stateObj);
  }

  notifyUpdated() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Answer Updated Successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyFailedToUpdate(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  validateCells(answer) {
    if (answer == "") {
      this.notifyMsgFieldEmpty();
      return false;
    } else {
      return true;
    }
  }

  notifyMsgFieldEmpty() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please fill all the fields
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyMsgDeleteSuccess() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Answer Deleted Successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  nNotifyFailToDelete(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  refreshData = () => {
    this.setState({ disabled: false, contentList: [], isLoading: true });
    this.fetchProjectWebsiteContentApi();
  };

  goBackFromSubTab = () => {
    this.props.history.push({
      pathname: "/projectmgmt/manage-knowledge/website-reading",
      state: { goBackToWebsiteReading: true },
    });
  };

  componentDidMount() {
    var projectWebsiteId = this.props.location.state.projectWebsiteId;
    this.state.projectWebsiteId = projectWebsiteId;
    this.setState(this.state);
    setTimeout(() => {
      this.fetchProjectWebsiteContentApi();
    }, 300);

    document.addEventListener("projectChanged", function (event) {
      window.location.href = "/platform/projectmgmt/manage-knowledge/website-reading";
    });
  }

  onPageChange = (e) => {
    this.setState({ pageNum: e });
  };

  fetchProjectWebsiteContentApi = () => {
    var thisController = this;
    var projectWebsiteId = thisController.props.location.state.projectWebsiteId;
    this.state.isLoading = true;
    this.setState(this.state);
    $.ajax({
      url: `/api/project-website-content`,
      async: false,
      method: "GET",
      data: {
        projectWebsiteId: projectWebsiteId,
        projectId: localStorage.getItem("currentProjectId"),
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        if (res.success === true) {
          var content = res.result;
          thisController.setState({
            contentList: content,
            disabled: false,
            isLoading: false,
          });
        } else {
          thisController.NotifyFailToLoad();
          thisController.setState({
            isLoading: false,
          });
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      },
    });
  };

  handleContentClick = (content) => {
    this.setState({
      content: content.content,
      showContentOverlay: true,
    });
  };

  closeContentOverlay = () => {
    this.setState({
      content: "",
      showContentOverlay: false,
    });
  };

  render() {
    return (
      <div style={{ background: "#F9F9FB" }}>
        {/* for toaster */}
        <link rel="stylesheet" href="assets/css/ReactToastify.css" />
        {/* for reactTable */}
        <link
          rel="stylesheet"
          href="assets/css/React_Table_CSS/react-table.css"
        />

        {/*for dialog component */}
        <link href="assets/css/ej2-base.css" rel="stylesheet" />
        <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
        <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
        <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
        <link href="assets/css/screenResolution.css" rel="stylesheet" />
        {/* Font Awesome Icons */}
        <link
          rel="stylesheet"
          href="plugins/font-awesome/css/font-awesome.min.css"
        />
        {/* IonIcons */}
        <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
        {/* Select2 */}
        <link rel="stylesheet" href="plugins/select2/select2.min.css" />
        <link rel="stylesheet" href="assets/css/toggleButton.css" />

        <div className="content-header">
          <div className="container-fluid">
            <div className="row"></div>
            <div className="row">
              <div className="col-sm-4" style={{ marginTop: "16px" }}>
                <img
                  src="assets/images/arrow.svg"
                  style={{ paddingRight: "30%", cursor: "pointer" }}
                  onClick={this.goBackFromSubTab}
                />
              </div>
              <div className="col-sm-4">
                <h6
                  className="nav-item"
                  style={{
                    color: "#282a65",
                    textAlign: "center",
                    marginTop: "16px",
                  }}
                >
                  Content
                </h6>
                {/* <h6 className="taglineTxt" style={{ textAlign: 'center' }}>FAQ Answers</h6> */}
              </div>
              {/* Add button */}
              <div
                className="d-flex flex-row-reverse pt-2 col-sm-2"
                align="right"
              >
                <button
                  title="Refresh"
                  onClick={this.refreshData}
                  type="button"
                  className="btn action-button"
                >
                  <img src="./assets/images/refresh_white_24dp.png"></img>
                </button>
              </div>
            </div>
          </div>
          {/* left Menu start here*/}
          {/* Content Header (Page header) */}
          {/* /.content-header */}
          {/* Custom Tabs */}
          <div className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="card-body p-0 mb-25">
                    <div className="tab-content col-12 p-0">
                      <div className="tab-pane active show" id="tab_1">
                        <div className="card card-primary mt-3">
                          <div
                            className="card-body raise-form"
                            style={{ minHeight: "450px" }}
                          >
                            <div className="row">
                              <div
                                className="col-12"
                                style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}
                              >
                                {this.state.isLoading && (
                                  <p
                                    style={{
                                      color: "#282a65",
                                      textAlign: "center",
                                      marginTop: "16px",
                                    }}
                                  >
                                    Loading...
                                  </p>
                                )}{" "}
                                {!this.state.isLoading &&
                                  this.state.contentList.length === 0 && (
                                    <p
                                      style={{
                                        color: "#282a65",
                                        textAlign: "center",
                                        marginTop: "16px",
                                      }}
                                    >
                                      No Content.
                                    </p>
                                  )}
                                {this.state.contentList.map(
                                  (content, index) => (
                                    <div
                                      style={{
                                        display: "inline-grid",
                                        marginRight: "2rem",
                                        cursor: "pointer",
                                      }}
                                      key={index}
                                      onClick={() =>
                                        this.handleContentClick(content)
                                      }
                                    >
                                      <img
                                        className="display-file-icon"
                                        src="./assets/images/txt_icon.png"
                                        alt="txt_icon"
                                      />
                                    </div>
                                  )
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12 ">
                  <div className="card">
                    {/* <div className="table-responsive manageClientTableBox"> */}
                  </div>
                  <ToastContainer className="Toast-at-center" />

                  {/*Overlay to show  content details*/}
                  <div className="wrapper">
                    <div
                      className="modal"
                      style={{
                        display: this.state.showContentOverlay
                          ? "block"
                          : "none",
                      }}
                    >
                      <div className="modal-dialog" style={{ marginTop: "1%" }}>
                        <div
                          className="modal-content"
                          style={{ height: "46rem", width: "46rem" }}
                        >
                          <div
                            className="modal-header noBorder"
                            style={{ height: "39px" }}
                          >
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              id="close_id"
                              onClick={this.closeContentOverlay}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                              >
                                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                <path d="M0 0h24v24H0z" fill="none" />
                              </svg>
                            </button>
                          </div>
                          <div
                            className="modal-body"
                            style={{ overflowY: "auto" }}
                          >
                            {this.state.content ? (
                              <p
                                style={{
                                  fontSize: "16px",
                                  lineHeight: "1.7rem",
                                }}
                              >
                                {this.state.content}
                              </p>
                            ) : (
                              <div
                                style={{
                                  textAlign: "center",
                                  marginTop: "1rem",
                                }}
                              >
                                No Content is Present
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*Dialog Component For Deletion Confirmation*/}
                  <DialogComponent
                    width="400px"
                    animationSettings={this.settings}
                    header="Answers"
                    showCloseIcon={true}
                    buttons={this.buttons}
                    ref={(dialog) => (this.dialogInstance = dialog)}
                    visible={this.state.hideDeletePopup}
                    close={this.dialogClose}
                  >
                    <img
                      src="assets/images/warn.svg"
                      style={{
                        paddingRight: "0px",
                        height: "20px",
                        width: "20px",
                      }}
                      content=""
                    />
                    &nbsp;Do you want to delete the
                    Answer?&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Note: Press
                    'Yes' to delete or press 'No' to decline.
                  </DialogComponent>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ContentDetails;



// WEBPACK FOOTER //
// ./src/projectmgmt/faq/ContentDetails.js